/**
 * Wrapper around the Polaris `BreadcrumbGroup` that implements client-side routing using react-router.
 *
 * @link https://polaris.a2z.com/components/breadcrumb-group
 *
 * Cloudscape's `BreadcrumbGroup` exposes its own `onFollow` event for link
 * navigation (each breadcrumb item renders an internal `<a href>`). We must
 * intercept `onFollow`, call `preventDefault`, and route via `navigate()` —
 * otherwise the underlying `<a>` performs a full browser reload.
 *
 * The earlier version of this file attached the handler to `onClick`, which
 * is NOT the navigation event for `BreadcrumbGroup`. With `{...props}` spread
 * after `onClick`, Cloudscape's defaults won and the link did a real reload.
 * This regression was visible only with the Orion sidenav present (which made
 * cross-page navigation easy and the bug obvious) — Classic users rarely
 * hit it because they navigated less.
 */

import { BreadcrumbGroup, BreadcrumbGroupProps } from 'src/common/UIComponents';
import { useNavigate } from 'react-router';

export function Breadcrumbs(props: BreadcrumbGroupProps) {
  const navigate = useNavigate();
  return (
    <BreadcrumbGroup
      {...props}
      onFollow={(event: any) => {
        // perform client side routing — prevent the underlying <a> from
        // doing a real browser navigation
        event.preventDefault();
        navigate(event.detail.href);
      }}
    />
  );
}
